import { SelectableTileGrid } from 'entities/kyrgyzstan/ui/create-object'

import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const OBJECT_TYPE_SKELETON_TILE_COUNT = 6

export const ObjectTypeStepSkeleton = () => (
  <SelectableTileGrid>
    {Array.from({ length: OBJECT_TYPE_SKELETON_TILE_COUNT }).map((_, index) => (
      <div
        key={index}
        className={s.tile}
      >
        <Skeleton
          width={20}
          height={20}
          borderRadius={6}
        />

        <Skeleton
          width="70%"
          height={18}
          borderRadius={6}
        />
      </div>
    ))}
  </SelectableTileGrid>
)
